import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { clearConversation, createConversation, deleteConversation, fetchConversation, getConversation, updateConversation } from '../../services/conversation';

const OneChat = ({ item, setChats, setIsChatSelected, setHistoryArray, isChatSelected, creativity, setCreativity }) => {

    const [editMode, setEditMode] = useState(false)
    const [deleteMode, setDeleteMode] = useState(false)
    const [inputValue, setInputValue] = useState(item.title || "New Conversation")

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    }

    const handleDismiss = () => {
        setInputValue(item.title);
        setEditMode(false);
    }

    const handleDismissDelete = () => {
        setDeleteMode(false)
    }

    const handleDeleteChat = async (id) => {

        try {
            const response = await deleteConversation(id);

            if (response.status === 'success') {

                if (isChatSelected === id) {
                    setIsChatSelected(null);
                    setHistoryArray([]);
                    setCreativity(0.5);
                }

                setChats((prev) => {
                    return prev.filter((item) => {
                        return id !== item.id;
                    })
                })
            } else throw new Error("Failed to delete Conversation");

        } catch (e) {
            toast(
                e?.message
                    ? e?.message
                    : "An error occured. Please try again"
            );
        };


    }

    const updateChat = async (id, title) => {

        try {
            const response = await updateConversation(id, { title });

            if (response.status === 'success') {
                setChats((prev) => {
                    return prev.map((item) => {
                        if (item.id === id) {
                            return {
                                ...item, title
                            }
                        } else {
                            return item;
                        }
                    })
                })

                setEditMode(false);
            } else throw new Error("Failed to Update Conversation");

        } catch (e) {
            toast(
                e?.message
                    ? e?.message
                    : "An error occured. Please try again"
            );

            setEditMode(false);
        };



    }

    return <div className="pt-2" >
        <div className="flex w-full flex-col gap-1">
            <div className="relative flex items-center">
                <button onClick={async () => {

                    try {
                        const response = await fetchConversation(item.id);

                        setHistoryArray(response?.conversation?.conversationArray);
                        setIsChatSelected(item.id);
                        setCreativity(item.creativity);

                    } catch (error) {
                        console.log(error);
                    }
                }} className={`flex w-full cursor-pointer items-center gap-3 rounded-lg p-3 text-sm transition-colors duration-200 ${isChatSelected === item.id ? 'bg-[#343541]/20' : 'hover:bg-gray-500/10'}`} draggable="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-message">
                        <path d="M8 9h8"></path><path d="M8 13h6">
                        </path>
                        <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z"></path>
                    </svg>
                    {
                        editMode ? <input
                            onChange={handleInputChange}
                            className="mr-12 flex-1 overflow-hidden overflow-ellipsis border-neutral-400 bg-transparent text-left text-[12.5px] leading-3 text-black outline-none focus:border-neutral-100"
                            type="text" value={inputValue}></input> :
                            <div className="relative max-h-5 flex-1 overflow-hidden text-ellipsis whitespace-nowrap break-all text-left text-[12.5px] leading-3 pr-12">
                                {inputValue}
                            </div>
                    }

                </button>
                {
                    (editMode || deleteMode) ? <div className="absolute right-1 z-10 flex text-gray-300">
                        <button onClick={() => {
                            if (editMode) {
                                updateChat(item.id, inputValue)
                            } else {
                                handleDeleteChat(item.id, inputValue)
                            }
                        }} className="min-w-[20px] p-1 text-neutral-400 hover:text-black">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-check">
                                <path d="M5 12l5 5l10 -10"></path>
                            </svg>
                        </button>
                        <button onClick={() => {
                            if (editMode) {
                                handleDismiss();
                            } else {
                                handleDismissDelete();
                            }
                        }} className="min-w-[20px] p-1 text-neutral-400 hover:text-black">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-x">
                                <path d="M18 6l-12 12"></path>
                                <path d="M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>
                        : <div className="absolute right-1 z-10 flex text-gray-300">
                            <button onClick={() => setEditMode(true)} className="min-w-[20px] p-1 text-neutral-400 hover:text-black">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-pencil">
                                    <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
                                    <path d="M13.5 6.5l4 4"></path>
                                </svg>
                            </button>
                            <button onClick={() => setDeleteMode(true)} className="min-w-[20px] p-1 text-neutral-400 hover:text-black">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-trash">
                                    <path d="M4 7l16 0"></path>
                                    <path d="M10 11l0 6"></path>
                                    <path d="M14 11l0 6"></path>
                                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                </svg>
                            </button>
                        </div>
                }
            </div>
        </div>
    </div>
}


function LeftPanel({ summaryLoading, setHistoryArray, setIsChatSelected, chats, setChats, isChatSelected, creativity, setCreativity }) {

    const [leftPanel, setLeftPanel] = useState(true);
    const [searchValue, setSearchValue] = useState("");
    const [clearConversationClicked, setClearConversationClicked] = useState(false);

    const addNewChat = async () => {
        const currChats = chats;

        try {
            const response = await createConversation({ title: `New Conversation`, conversationArray: [] })

            if (response.status === 'success') {
                setChats([response.conversation, ...currChats]);
                setIsChatSelected(response.conversation.id)
                setHistoryArray([]);
            } else throw new Error("Failed to create New Chat");

        } catch (e) {

            toast(
                e?.message
                    ? e?.message
                    : "An error occured. Please try again"
            );
        };
    }

    const getAllConversation = async () => {
        try {
            const response = await getConversation();

            if (response.status === 'success') {
                setChats(response.conversations);
            } else throw new Error("Failed to Fetch Conversation");

        } catch (e) {
            toast(
                e?.message
                    ? e?.message
                    : "An error occured. Please try again"
            );
        };
    }

    useEffect(() => {
        getAllConversation();
    }, [])

    const clearConversationProcess = async () => {

        const userConfirmed = window.confirm("Are you sure you want to clear the conversation?");
        if (!userConfirmed) {
            return; // Exit the function if the user cancels
        }

        try {
            const response = await clearConversation();

            if (response.status === 'success') {
                setChats([]);
                setClearConversationClicked(false);
                setIsChatSelected(null);
                setHistoryArray([]);
            } else throw new Error("Failed to Fetch Conversation");

        } catch (e) {
            toast(
                e?.message
                    ? e?.message
                    : "An error occured. Please try again"
            );
        };
    }

    return (
        <>
            {
                leftPanel ? <div>
                    <div className="overflow-scroll fixed top-0 left-0 z-40 flex h-full w-[260px] flex-none flex-col space-y-2 bg-[#f0f0f0] p-2 text-[14px] text-black transition-all sm:relative sm:top-0">
                        <div className="flex items-center gap-2">
                            <button onClick={addNewChat} className="text-sidebar flex flex-1 cursor-pointer select-none items-center gap-3 rounded-md border border-white/20 p-3 text-black transition-colors duration-200 hover:bg-gray-500/10"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-plus">
                                <path d="M12 5l0 14"></path><path d="M5 12l14 0"></path>
                            </svg>
                                New Chat
                            </button>
                            {/* <button className="flex flex-shrink-0 cursor-pointer items-center gap-3 rounded-md border border-white/20 p-3 text-sm text-black transition-colors duration-200 hover:bg-gray-500/10">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-folder-plus">
                            <path d="M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5"></path>
                            <path d="M16 19h6"></path>
                            <path d="M19 16v6"></path>
                        </svg>
                    </button> */}
                            <button onClick={() => {
                                setLeftPanel(false)
                            }} className="left-[270px] z-50 rounded-md border border-white/20 sm:top-0.5 sm:left-[270px] p-2 sm:text-neutral-700 transition-colors duration-200 hover:bg-gray-500/10">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-arrow-bar-left"><path d="M4 12l10 0">
                                </path>
                                    <path d="M4 12l4 4"></path><path d="M4 12l4 -4">
                                    </path>
                                    <path d="M20 4l0 16">
                                    </path>
                                </svg>
                            </button>
                            <div className="top-0 left-0 z-10 h-full w-full bg-black opacity-70 sm:hidden">
                            </div>
                        </div>
                        <div className="relative flex items-center">
                            <input value={searchValue} onChange={(e) => setSearchValue(e.target.value)} className="w-full flex-1 rounded-md border border-neutral-600 bg-[#2343541] px-4 py-3 pr-10 text-[14px] leading-3 text-black" type="text" placeholder="Search..." />
                        </div>
                        {
                            chats && chats.length === 0 ? <div className="flex-grow overflow-auto">
                                <div className="mt-8 select-none text-center text-black opacity-50">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="mx-auto mb-3">
                                        <path d="M12 5h9"></path>
                                        <path d="M3 10h7"></path>
                                        <path d="M18 10h1"></path>
                                        <path d="M5 15h5"></path>
                                        <path d="M14 15h1m4 0h2"></path>
                                        <path d="M3 20h9m4 0h3"></path>
                                        <path d="M3 3l18 18"></path>
                                    </svg>
                                    <span className="text-[14px] leading-normal">No data.</span>
                                </div>
                            </div> : <div className="flex-grow overflow-auto">
                                {
                                    chats.filter((item) => item.title.includes(searchValue)).map((item) => {
                                        return <OneChat key={item.id} item={item} setChats={setChats} setIsChatSelected={setIsChatSelected} isChatSelected={isChatSelected}
                                            setHistoryArray={setHistoryArray} creativity={creativity} setCreativity={setCreativity} />
                                    })
                                }
                            </div>
                        }

                        {
                            chats && chats.length && !clearConversationClicked ? <div className="flex flex-col items-center space-y-1 border-t border-white/20 pt-1 text-sm">
                                <button onClick={() => setClearConversationClicked(true)} className="flex w-full cursor-pointer select-none items-center gap-3 rounded-md py-3 px-3 text-[14px] leading-3 text-black transition-colors duration-200 hover:bg-gray-500/10">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-trash">
                                            <path d="M4 7l16 0"></path>
                                            <path d="M10 11l0 6"></path>
                                            <path d="M14 11l0 6"></path>
                                            <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                            <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                        </svg>
                                    </div>
                                    <span>Clear conversations</span>
                                </button>
                                {/* <button className="flex w-full cursor-pointer select-none items-center gap-3 rounded-md py-3 px-3 text-[14px] leading-3 text-black dark:text-white transition-colors duration-200 hover:bg-gray-500/10">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-settings">
                                        <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
                                        <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
                                    </svg>
                                </div>
                                <span>Settings</span>
                            </button> */}
                            </div> : null


                        }

                        {
                            clearConversationClicked ? <div className="flex w-full cursor-pointer items-center rounded-lg py-3 px-3 hover:bg-gray-500/10">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-trash">
                                    <path d="M4 7l16 0"></path>
                                    <path d="M10 11l0 6"></path>
                                    <path d="M14 11l0 6"></path>
                                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                </svg>
                                <div className="ml-3 flex-1 text-left text-[12.5px] leading-3 text-black">Are you sure?</div>
                                <div className="flex w-[40px]">
                                    <svg onClick={clearConversationProcess} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="ml-auto mr-1 min-w-[20px] text-neutral-400 hover:text-black">
                                        <path d="M5 12l5 5l10 -10"></path>
                                    </svg>
                                    <svg onClick={() => setClearConversationClicked(false)} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="ml-auto min-w-[20px] text-neutral-400 hover:text-black">
                                        <path d="M18 6l-12 12"></path>
                                        <path d="M6 6l12 12"></path>
                                    </svg>
                                </div>
                            </div> : null
                        }


                    </div>
                </div> : <button onClick={() => {
                    setLeftPanel(true)
                }} className="left-2 z-50 border rounded-md border-white/20 text-black sm:top-0.5 sm:left-2 p-2 sm:text-neutral-700 transition-colors duration-200 hover:bg-gray-500/10">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-arrow-bar-right">
                        <path d="M20 12l-10 0"></path>
                        <path d="M20 12l-4 4"></path>
                        <path d="M20 12l-4 -4"></path>
                        <path d="M4 4l0 16"></path>
                    </svg>
                </button>
            }
        </>
    )

}

export default LeftPanel